import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { forceBackendCheck } from '../utils/backendStatus.ts';
import './SetupBackendIP.css';

const SetupBackendIP: React.FC = () => {
  const [backendIp, setBackendIp] = useState('');
  const [detectedIp, setDetectedIp] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Detectar IP da URL atual
    const hostname = window.location.hostname;
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    
    if (ipRegex.test(hostname)) {
      setDetectedIp(hostname);
      setBackendIp(hostname);
    }
    
    // Carregar IP salvo
    const savedIP = localStorage.getItem('backend_ip');
    if (savedIP) {
      setBackendIp(savedIP);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Sanitizar entrada: remover espaços e caracteres não permitidos
    const sanitizedIp = backendIp.trim().replace(/[^0-9.]/g, '');
    
    // Validar formato de IP
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    
    if (!ipRegex.test(sanitizedIp)) {
      alert('IP inválido! Use o formato: 192.168.x.x');
      return;
    }
    
    // Validar que cada octeto está entre 0 e 255
    const octets = sanitizedIp.split('.');
    const isValidOctets = octets.every(octet => {
      const num = parseInt(octet, 10);
      return num >= 0 && num <= 255;
    });
    
    if (!isValidOctets) {
      alert('IP inválido! Cada número deve estar entre 0 e 255.');
      return;
    }
    
    // Validar que não é um IP reservado/perigoso
    const reservedIps = ['0.0.0.0', '127.0.0.1', '255.255.255.255'];
    if (reservedIps.includes(sanitizedIp)) {
      alert('IP inválido! Este IP é reservado e não pode ser usado.');
      return;
    }
    
    // Salvar IP validado
    localStorage.setItem('backend_ip', sanitizedIp);
    setSuccess(true);
    
    // Forçar verificação do backend com o novo IP
    console.log('[SetupBackendIP] IP salvo, forçando verificação do backend...');
    forceBackendCheck((isOnline) => {
      console.log('[SetupBackendIP] Backend status após atualização:', isOnline ? 'ONLINE' : 'OFFLINE');
    });
    
    // Redirecionar após 2 segundos
    setTimeout(() => {
      navigate('/');
    }, 2000);
  };

  return (
    <div className="setup-backend-ip-container">
      <div className="setup-backend-ip-card">
        <h1>🔧 Configurar IP do Backend</h1>
        <p>Configure o IP do servidor backend para acesso do dispositivo móvel.</p>
        
        <div className="info-box">
          <strong>💡 Como descobrir o IP:</strong><br />
          1. No seu computador, execute: <code>ifconfig | grep "inet " | grep -v 127.0.0.1</code><br />
          2. Ou use: <code>ipconfig getifaddr en0</code> (macOS)<br />
          3. Procure por um IP como: <strong>192.168.x.x</strong>
        </div>
        
        {detectedIp && (
          <div className="detected-ip-box">
            <strong>📱 IP detectado da URL atual:</strong><br />
            <span>{detectedIp}</span>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="ip-form">
          <div className="form-group">
            <label htmlFor="backendIp">IP do Backend:</label>
            <input
              type="text"
              id="backendIp"
              value={backendIp}
              onChange={(e) => setBackendIp(e.target.value)}
              placeholder="Ex: 192.168.10.17"
              pattern="^(\d{1,3}\.){3}\d{1,3}$"
              required
            />
            <small>Apenas o IP, sem http:// ou porta</small>
          </div>
          
          <button type="submit" className="submit-button">
            Salvar Configuração
          </button>
        </form>
        
        {success && (
          <div className="success-box">
            <strong>✅ Configuração salva!</strong><br />
            Redirecionando...
          </div>
        )}

        <div className="links-section">
          <Link to="/settings" className="link-button">
            ⚙️ Voltar para Configurações
          </Link>
          <Link to="/login" className="link-button">
            🔐 Ir para Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SetupBackendIP;

